import { observer } from "mobx-react-lite"
import styles from "./styles.module.scss"
import Close from "~icons/eva/close-outline"
import Checkmark from "~icons/eva/checkmark-outline"
import { getStripeExternalSubscriptionManageUrl } from "../../../services/firebase-functions/billing"
import { useMutation } from "@tanstack/react-query"
import { useStores } from "../../../models/helpers/useStores"

const SubscriptionRenewedModal = ({ onClose }: { onClose: () => void }) => {
  return (
    <div className={styles.container}>
      <div className={styles.successWrapper}>
        <div className={styles.successIconWrapper}>
          <Checkmark className={styles.icon} />
        </div>
        <h2 className={styles.title}>
          Subscription renewed
          <br />
          successfully!
        </h2>
        <button className={styles.continueButton} onClick={() => onClose()}>
          Done
        </button>
        <button className={styles.closeButton} onClick={() => onClose()}>
          <Close className={styles.closeIcon} />
        </button>
      </div>
    </div>
  )
}

export const InactiveSubscriptionModal = observer(({ onClose }: { onClose: () => void }) => {
  const rootStore = useStores()
  const { mutate: goToManageSubscription, isPending } = useMutation({
    mutationFn: () => getStripeExternalSubscriptionManageUrl(),
    onSuccess: (subscriptionManageUrl) => {
      if (subscriptionManageUrl) {
        window.open(subscriptionManageUrl, "_blank").focus()
      }
    },
  })

  const isRenewed = rootStore.stripeSubscription?.status === "active"

  if (isRenewed) {
    return <SubscriptionRenewedModal onClose={onClose} />
  }

  return (
    <div className={styles.container}>
      <header className={styles.header}>
        <div className={styles.iconWrapper}>
          <Close className={styles.icon} />
        </div>
        <h2 className={styles.title}>Your subscription is inactive</h2>
      </header>
      <div className={styles.subscriptionDetails}>
        <p className={styles.description}>
          We were unable to renew your subscription after multiple attempts. Please update your
          payment details to continue enjoying full access to Cruisen - we’ll process the renewal
          right away!
        </p>
        <button
          className={styles.continueButton}
          disabled={isPending}
          onClick={() => goToManageSubscription()}
        >
          {isPending ? "Loading..." : "Manage my subscription"}
        </button>
      </div>
    </div>
  )
})
